/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Other_EmailInputs */

const en_portalsignin_other_email = /** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a different email`)
};

/** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */
const ar_portalsignin_other_email = en_portalsignin_other_email;

/** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */
const he_portalsignin_other_email = en_portalsignin_other_email;

/** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */
const ur_portalsignin_other_email = en_portalsignin_other_email;

/** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */
const es_portalsignin_other_email = en_portalsignin_other_email;

/** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */
const fr_portalsignin_other_email = en_portalsignin_other_email;

/** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */
const de_portalsignin_other_email = en_portalsignin_other_email;

/** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */
const pt_portalsignin_other_email = en_portalsignin_other_email;

/** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */
const hi_portalsignin_other_email = en_portalsignin_other_email;

/** @type {(inputs: Portalsignin_Other_EmailInputs) => LocalizedString} */
const bn_portalsignin_other_email = en_portalsignin_other_email;

/**
* | output |
* | --- |
* | "Use a different email" |
*
* @param {Portalsignin_Other_EmailInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_other_email = /** @type {((inputs?: Portalsignin_Other_EmailInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Other_EmailInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_other_email(inputs)
	if (locale === "he") return he_portalsignin_other_email(inputs)
	if (locale === "ur") return ur_portalsignin_other_email(inputs)
	if (locale === "es") return es_portalsignin_other_email(inputs)
	if (locale === "fr") return fr_portalsignin_other_email(inputs)
	if (locale === "de") return de_portalsignin_other_email(inputs)
	if (locale === "pt") return pt_portalsignin_other_email(inputs)
	if (locale === "hi") return hi_portalsignin_other_email(inputs)
	if (locale === "bn") return bn_portalsignin_other_email(inputs)
	return /** @type {LocalizedString} */ ("Use a different email")
});